<!--
    项目详情
-->
<template>
    <div class="content_warp">
        <!-- 项目信息 -->
        <div class="content_box">
            <div class="user_info">
                <p>{{ objAccount.name }}</p>
                <p>{{ objAccount.new_telephone }}</p>
            </div>
            <div class="project_name">{{ objProject.new_name }}</div>
            <div :class="['contract_state',{'contract_state2':objContract.new_status == 4}]">
                {{ objContract.new_status_name }}
            </div>
            <div class="plan_lable">
                <p>{{ objAccount.new_area ? objAccount.new_area + ' m²' : '不详' }}</p>
                <p>
                    {{ objAccount.new_roomnumber ? objAccount.new_roomnumber + '室' : '' }}{{
                        objAccount.new_hall ? objAccount.new_hall + '厅' : ''
                    }}{{ objAccount.new_toilet ? objAccount.new_toilet + '卫' : '' }}{{
                        objAccount.new_kitchen ? objAccount.new_kitchen + '厨' : ''
                    }}
                </p>
                <p>{{ objAccount.new_housetype_name ? objAccount.new_housetype_name : '不详' }}</p>
            </div>
        </div>
        <!-- 菜单 -->
        <div class="schedule_box">
            <div class="schedule_top">
                项目资料库
            </div>
            <div class="schedule_menu">
                <div v-for="(item,index) in arrScheduleMennu" :key="index" @click="touchMenu(index)"
                     :class="{'schedule_item':true,'schedule_item_select':nScheduleMennuIndex == index}">
                    <img v-if="nScheduleMennuIndex == index" :src="item.img" alt="">
                    <img v-else :src="item.img_no" alt="">
                    <p>{{ item.text }}</p>
                    <div :class="{'slip':true,'slip_select':nScheduleMennuIndex == index}"></div>
                </div>
            </div>
        </div>
        <!-- 项目团队 -->
        <div v-show="nScheduleMennuIndex != 0" class="team_info">
            <template v-if="!(objMainShow&&objMainShow.id)">
                <div class="member_info">
                    <img class="member_head" src="~@/assets/images/user/housev2/head_default.png" alt="">
                    <div>
                        <div class="member_number member_number_not">
                            <p>待指派</p>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="member_info">
                    <img class="member_head" v-lazy="objMainShow.icon" alt="">
                    <div>
                        <div class="member_number">
                            <p>{{ objMainShow.rel_group_name }}</p>
                            <p v-if="objMainShow.job_number">工牌：{{ objMainShow.job_number }}</p>
                        </div>
                        <p class="member_name">{{ objMainShow.name }}</p>
                        <div v-if="false" class="member_reate">
                            <van-rate v-model="reate" :size="16" allow-half readonly color="#FCBF82"
                                      void-icon="star" void-color="#eee"/>
                            <p style="font-size: 12px;line-height: 12px;">{{ reate }} 分</p>
                        </div>
                    </div>
                    <img v-if="objMainShow.qr_code != ''"
                         @click.stop="showQrcodePopup(objMainShow.name,objMainShow.qr_code)"
                         class="phone_icon"
                         src="~@/assets/images/user/housev2/qrcode_icon.png" alt="">
                </div>
            </template>
            <template v-if="!objThemInfo.team || (objThemInfo.team && objThemInfo.team.length <= 0)">
                <div class="team_list">
                    <div class="team_item">项目团队：待指派</div>
                </div>
            </template>
            <template v-else>
                <div class="team_list">
                    <div class="team_item">项目团队：
                        <img v-for="(item,index) in objThemInfo.team" v-lazy="item.icon" alt="">
                    </div>
                    <div class="team_look" @click="touchLookTeam">
                        查看
                        <img src="~@/assets/images/user/housev2/arrw_icon2.png" alt="">
                    </div>
                </div>
            </template>

        </div>
        <!-- 项目日志 -->
        <div v-show="nScheduleMennuIndex == 0">
            <div :class="{'list_box':true,'list_box2':isShowShare}">
                <div class="line_box">
                    <div v-for="(item,index) in arrLog" :key="index" class="schedule_info">
                        <div class="schedule_title green" @click="touchUnfold(index)">
                            {{ item.title }}
                            <p>{{ item.isShow ? '收起' : '展开' }}</p>
                        </div>
                        <div :style="`overflow: hidden;height: ${item.isShow?'auto':'0'};`">
                            <div v-for="(item2,index2) in item.list" :key="index2" class="schedule_info_item">
                                <div class="schedule_time">
                                    <div class="dot green_dot"></div>
                                    <p>时间</p>
                                    <p>{{ item2.time }}</p>
                                </div>
                                <div class="schedule_msg">
                                    <p>
                                        {{ item2.text }}
                                        <template
                                            v-if="(item2.url && item2.url != '' &&  item.type == 1)  || item.type == 2  || (item.type == 3 && item2.process && item2.process > 0)  ">
                                            ， <span @click="touchLook(item.type,item2)">点击查看</span>
                                        </template>
                                    </p>
                                </div>
                                <div v-if="item2.image && item2.image.length > 0" class="img_box">
                                    <img v-for="(item3,index3) in item2.image" :key="item3.annotationid"
                                         :src="item3.new_filepath" @click="touchLookImg(item2.image,index3)" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 产品清单 -->
        <div v-show="nScheduleMennuIndex == 1">
            <div :class="{'product_box':true,'product_box2':isShowShare}">
                <div class="product_title">设备详情</div>
                <div v-if="objContractDetails.product_list" class="product_list">
                    <template v-if="objContractDetails.product_list.length > 3 && !isLookMore">
                        <template v-for="(item,index) in objContractDetails.product_list.slice(0,3)">
                            <div :key="index" class="product_item">
                                <div class="product_img">
                                    <img :src="item.img" alt="">
                                </div>
                                <div class="product_info">
                                    <div class="product_tpye">{{ item.type_name }}</div>
                                    <div class="product_name">
                                        <p>{{ item.name }}</p>
                                        <p>x{{ item.num }}</p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="(item,index) in objContractDetails.product_list">
                            <div :key="index" class="product_item">
                                <div class="product_img">
                                    <img :src="item.img" alt="">
                                </div>
                                <div class="product_info">
                                    <div class="product_tpye">{{ item.type_name }}</div>
                                    <div class="product_name">
                                        <p>{{ item.name }}</p>
                                        <p>x{{ item.num }}</p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <div v-if="objContractDetails.product_list.length > 3" class="lookMore" @click="touchLookMore">{{
                            !isLookMore ? '查看更多' : '收起'
                        }}
                    </div>
                </div>
            </div>
        </div>
        <!-- 设计方案 -->
        <div v-show="nScheduleMennuIndex == 2">
            <div class="design_title">3D设计方案</div>
            <div :class="{'design_3d':true,'design_3d2':isShowShare}">
                <iframe width="100%" height="100%"
                        :src="sDesignUrl"></iframe>
            </div>
        </div>
        <!-- 施工验收 -->
        <div v-show="nScheduleMennuIndex == 3">
            <!-- todo 0720隐藏，需要换新的 -->
            <!-- <div class="standard">
                <img src="@/assets/images/processv2/ascfx.png" alt="">
                <div class="text" @click="touchStandard">
                    <div class="text-l">查看</div>
                    <div class="text-r">《智慧集成系统质量管理标准》</div>
                </div>
            </div> -->
            <div :class="{'report-wrap':true,'report-wrap2':isShowShare}">
                <template v-for="(item,index) in arrProcessList">
                    <div class="report-item">
                        <div class="title-date">{{ item.date_tips }}</div>
                        <div class="report-content" @click="touchProcess(item)">
                            <div class="it-title">
                                <div class="title">{{ item.title }}</div>
                                <div class="state" :style="{'color':item.fin_status?'#0D53FC':'#DA822E'}">{{
                                        item.fin_status ? '已交付' : '待交付'
                                    }}
                                </div>
                            </div>
                            <div class="it-center">
                                <div class="image-wrap">
                                    <div class="img-l">
                                        <template v-for="(imgIt,imgIndex) in item.attach">
                                            <div class="img-w" v-if="imgIndex<4">
                                                <img :src="imgIt" alt="">
                                            </div>
                                        </template>
                                    </div>
                                    <div class="img-r" v-if="item.fin_status">
                                        <img src="@/assets/images/processv2/dsvgx.png" alt="">
                                    </div>
                                </div>
                                <div class="quality">
                                    <template v-for="tag in item.cate_list">
                                        <div class="quality-item">
                                            <img v-if="item.fin_status" src="@/assets/images/processv2/dsvgdx.png"
                                                 alt="">
                                            <!--                                        <img v-else src="@/assets/images/processv2/ds2gdx.png" alt="">-->
                                            <p v-else></p>
                                            <div class="tag-text">{{ tag }}</div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="it-bottom">
                                查看详情
                            </div>
                        </div>
                        <!-- 虚线上方图标-->
                        <div class="tag-icon" :style="{'background':item.fin_status?'#355D4B':'#D1D9D4'}"></div>
                        <!-- 虚线-->
                        <div class="line"></div>
                    </div>
                </template>
            </div>
        </div>

        <div v-if="!trackAction && isShowBackHome" class="home_icon" @click="touchBack"
             :style="{bottom: isShowShare ? '180px':'120px'}">
            <img src="~@/assets/images/processv2/tohome.png"/>
        </div>
        <div class="fixed_box" :style="{bottom: isShowShare ? '110px':'50px'}" @click="toEval"
             v-if="objContract.new_status == 4">
            <img src="~@/assets/images/user/housev2/mail_icon.png" alt="">
            <p>我要<br/>评价</p>
        </div>

        <share ref="myShare" v-if="isShowShare" :isFixed="true"></share>
        <qrcodePopup :nPopup.sync="isQrcodePopup" :nEwmImg="sQcCodeImg" :nTitle="sQrcodeName"
                     @changeTag="showQrcodePopup"></qrcodePopup>
    </div>
</template>

<script>
import {
    getProjectDetails,
    getProjectTeam,
    getProjectLog,
    getContractDetails,
    getProcessList,
    discussShare
} from "@/js/designer/index.js";
import qrcodePopup from '../components/qrcode.vue';
import share from "../components/share.vue"
import {ImagePreview} from "vant";

export default {
    name: "DesignerProject_useKP",
    components: {
        qrcodePopup,
        share
    },
    data() {
        return {
            isShowBackHome: true,//是否展示返回icon
            objAccount: {}, //用户信息
            objProject: {}, //项目信息
            objContract: {}, //合同信息
            nScheduleMennuIndex: 0,
            arrScheduleMennu: [{
                img: require('/src/assets/images/designer/tab_item1.png'),
                img_no: require('/src/assets/images/designer/tab_item1_no.png'),
                text: '项目日志'
            }, {
                img: require('/src/assets/images/designer/tab_item2.png'),
                img_no: require('/src/assets/images/designer/tab_item2_no.png'),
                text: '产品清单'
            }, {
                img: require('/src/assets/images/designer/tab_item3.png'),
                img_no: require('/src/assets/images/designer/tab_item3_no.png'),
                text: '方案设计'
            }, {
                img: require('/src/assets/images/designer/tab_item4.png'),
                img_no: require('/src/assets/images/designer/tab_item4_no.png'),
                text: '竣工验收'
            }],
            arrLog: [], //项目日志
            objContractDetails: {}, //产品详情 - 合同信息
            isLookMore: false, //产品详情 - 查看更多
            objThemInfo: {}, //项目团队信息
            objMainShow: {}, //主要展示的项目团队成员
            isQrcodePopup: false, //显示团队成员二维码
            sQcCodeImg: '',
            sQrcodeName: '',
            sDesignUrl: '', //3d设计的路径
            arrProcessList: [],//施工验收 - 交付报表列表
            isJGData: true,//是否有竣工数据
            isSgData: true,//是否有施工数据
            isShowShare: false,
            trackAction: '',
        }
    },
    created() {
        this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
        $init(() => {
            this.$oInitData.designerInfo({
                h5_user_id: this.$storage.getStorage("user_id"),
            }).then((res) => {
                let objData = this.$route.query;
                if (objData.sampleroom == 2) {
                    this.isShowShare = true;
                }
                this.pageInit();
                if (this.$route.query.form == 'aoquan') {
                    this.isShowBackHome = false
                }
            }).catch((error) => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            });
        })
    },
    activated() {
        let objPrject = this.$storage.getStorage('designer_prject');
        if (objPrject && (objPrject.new_contract_id != this.$route.query.new_contract_id || this.$route.query.track_action == 'member_share_design')) {
            this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
            $init(() => {
                this.$oInitData.designerInfo({
                    h5_user_id: this.$storage.getStorage("user_id"),
                }).then((res) => {
                    let objData = this.$route.query;
                    if (objData.sampleroom == 2) {
                        this.isShowShare = true;
                    }
                    this.pageInit();
                    if (this.$route.query.form == 'aoquan') {
                        this.isShowBackHome = false
                    }
                }).catch((error) => {
                    this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                });
            })
        }
    },
    watch: {
        '$route'(to, from) {
            if (from.path == '/designer/index/index') {
                this.nScheduleMennuIndex = 0;
                let objPrject = this.$storage.getStorage('designer_prject');
                if (this.objContract.new_contractid && objPrject.new_contract_id != this.objContract.new_contractid) {
                    this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
                    $init(() => {
                        this.$oInitData.designerInfo({
                            h5_user_id: this.$storage.getStorage("user_id"),
                        }).then((res) => {
                            let objData = this.$route.query;
                            if (objData.sampleroom == 2) {
                                this.isShowShare = true;
                            }
                            this.pageInit();
                        }).catch((error) => {
                            this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                        });
                    })
                }
            }
        }
    },
    methods: {
        // 跳转评价
        toEval() {
            this.$router.push({
                path: `/designer/evaluation/index`,
                query: {
                    project_uuid: this.objProject.new_srv_projectmgnid,
                    sampleroom: this.$route.query.sampleroom,
                    new_contract_id: this.$route.query.new_contract_id
                }
            })
        },
        pageInit() {
            if (this.$route.query.track_action && this.$route.query.track_action == 'member_share_design') {
                this.trackAction = this.$route.query.track_action;
                this.$storage.setStorage('designer_prject', {
                    new_srv_projectmgnid: this.$route.query.pId,
                    new_account_id: this.$route.query.aId,
                    new_contract_id: this.$route.query.cId,
                });
                discussShare({
                    project_uuid: this.$storage.getStorage('designer_prject').new_srv_projectmgnid || '',
                    share_id: this.$route.query.shareId
                })
            }
            if (this.$route.query.sampleroom == 2 || this.$route.query.form == 'aoquan') {
                this.$storage.setStorage('designer_prject', {
                    new_srv_projectmgnid: this.$route.query.new_srv_projectmgnid,
                    new_account_id: this.$route.query.new_account_id,
                    new_contract_id: this.$route.query.new_contract_id,
                });
            }
            this.getProjectDetailsFun()
        },
        //获取项目详情
        getProjectDetailsFun() {

            let objPrject = this.$storage.getStorage('designer_prject');
            console.log(objPrject, 'objPrject')
            getProjectDetails({
                accountid: objPrject.new_account_id,
                contractid: objPrject.new_contract_id,
            }).then((res) => {
                let result = res.data.result;
                console.log('getProjectDetails', result)
                this.objProject = result.project;
                if (!objPrject.new_name) {
                    objPrject.new_name = this.objProject.new_name;
                    this.$storage.setStorage('designer_prject', objPrject)
                }


                this.objAccount = result.account;
                this.$storage.setStorage('designer_account', this.objAccount)
                this.objAccount.new_telephone = this.objAccount.new_telephone.slice(0, 3) + '****' + this.objAccount.new_telephone.slice(-4);
                this.objContract = result.contract;

                Promise.all([
                    this.getProjectLogFun(),
                    this.getProjectTeamFun(),
                ]).then(() => {
                    this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                }).catch((err) => {
                    console.log(err)
                    this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                })
            }).catch((err) => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            })
        },
        //获取项目团队
        getProjectTeamFun() {
            return new Promise((resolve, reject) => {
                getProjectTeam({
                    projectmgnid: this.objProject.new_srv_projectmgnid,
                    sampleroom: this.$route.query.sampleroom || '',
                }).then((res) => {
                    let result = res.data.result;
                    console.log(result)
                    this.objThemInfo = result;
                    resolve()
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        //获取项目日志
        getProjectLogFun() {
            return new Promise((resolve, reject) => {
                getProjectLog({
                    project_id: this.objProject.new_srv_projectmgnid
                }).then((res) => {
                    let result = res.data.result;
                    console.log('getProjectLog', result)
                    let arrLog = [];
                    if (result.work.length > 0) {
                        result.work.forEach(it => {
                            it.time = this.handleTime(it.time)
                        })
                        arrLog.push({
                            title: '施工在线',
                            type: 3,
                            isShow: true,
                            list: result.work
                        })
                    }
                    if (result.design.length > 0) {
                        result.design.forEach(it => {
                            it.time = this.handleTime(it.time)
                        })

                        arrLog.push({
                            title: '设计方案',
                            type: 1,
                            isShow: true,
                            list: result.design
                        })
                    }
                    if (result.contract.length > 0) {
                        result.contract.forEach(it => {
                            it.time = this.handleTime(it.time)
                        })
                        arrLog.push({
                            title: '签订合同',
                            type: 2,
                            isShow: true,
                            list: result.contract
                        })
                    }
                    this.arrLog = arrLog;
                    resolve()
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        //获取项目产品详情
        getContractDetailsFun() {
            this.$store.commit("loadSwitch", true); // 页面loading开启
            let objPrject = this.$storage.getStorage('designer_prject')
            getContractDetails({
                contract_id: this.objContract.new_contractid
            }).then((res) => {
                let result = res.data.result;
                console.log('getContractDetails', result)
                this.objContractDetails = result;
                this.$store.commit("loadSwitch", false); // 页面loading关闭
            }).catch((err) => {
                console.log(err)
                this.$store.commit("loadSwitch", false); // 页面loading关闭
            })
        },
        //获取项目施工验收报告列表
        getProcessListFun() {

            this.$store.commit("loadSwitch", true); // 页面loading开启
            let objPrject = this.$storage.getStorage('designer_prject')
            getProcessList({
                projectmgnid: this.objProject.new_srv_projectmgnid,
            }).then((res) => {
                let result = res.data.result;
                console.log('getProcessList', result)
                this.arrProcessList = result.report;
                // 判断系统施工和全部施工是否已交付
                let isAll = this.arrProcessList.find(it => {
                    return it.fin_status == 0
                })
                let isSg = this.arrProcessList.find(it => {
                    if (it.is_completed == 0) {
                        return it.fin_status == 0
                    }
                })
                this.isAllYs = isAll ? false : true
                this.isSgYs = isSg ? false : true
                // 判断是否有施工和竣工数据
                let isSgD = this.arrProcessList.find(it => {
                    return it.is_completed == 0
                })
                let isJgD = this.arrProcessList.find(it => {
                    return it.is_completed == 1
                })
                this.isSgData = isSgD ? true : false
                this.isJGData = isJgD ? true : false
                this.$store.commit("loadSwitch", false); // 页面loading关闭
            }).catch((err) => {
                console.log(err)
                this.$store.commit("loadSwitch", false); // 页面loading关闭
            })
        },
        //处理时间格式
        handleTime(time) {
            if (time) {
                let arr = time.split(' ')
                return arr[0].slice(0, 4) + '年' + arr[0].slice(5, 7) + '月' + arr[0].slice(8) + '日 ' + arr[1].slice(0, -3) + ' 更新'
            } else {
                return '--'
            }
            // return arr[0].slice(5, 7) + '月' + arr[0].slice(8) + '日 ' + arr[1]
        },
        //切换菜单
        touchMenu(index) {
            this.nScheduleMennuIndex = index;
            switch (this.nScheduleMennuIndex) {
                case 0: //项目日志
                    break;
                case 1: //产品清单
                    this.objMainShow = this.objThemInfo.salesperson;
                    if (!this.objContractDetails.new_code) {
                        this.getContractDetailsFun()
                    }
                    break;
                case 2: //方案设计
                    if (this.arrLog[1].list && this.arrLog[1].list.length > 0) {
                        this.sDesignUrl = this.arrLog[1].list.find(it => {
                            return it.url
                        }).url;
                        console.log(this.sDesignUrl);
                    }
                    this.objMainShow = this.objThemInfo.designer;

                    break;
                case 3: //竣工验收
                    this.objMainShow = this.objThemInfo.manager;
                    this.getProcessListFun()
                    break;
            }
        },
        //项目日志点击查看
        touchLook(type, item) {
            switch (type) {
                case 1: //设计方案
                    this.$router.push({
                        path: "/designer/designer3d/index",
                        query: {
                            url: item.url,
                            name: item.name,
                            ...this.$route.query
                        }
                    });
                    break;
                case 2: //合同
                    this.$router.push({
                        path: "/designer/contract/index",
                        query: {
                            contractId: item.contract_id,
                            changeId: item.change_id,
                            ...this.$route.query
                        },
                    });
                    break;
                case 3: //施工在线
                    this.$router.push({
                        path: `/designer/process/index`,
                        query: {
                            id: item.process,
                            completed: 0,
                            ...this.$route.query
                        }
                    })
                    break;
            }
        },
        //查看全部项目点击查看图片
        touchLookImg(imgs, index) {
            let arrImg = imgs.map((e) => {
                return e.new_filepath
            })
            ImagePreview({
                images: arrImg,
                startPosition: index
            })
        },
        //查看全部项目成员
        touchLookTeam() {
            // this.$router.push({path: "/designer/team/index", query: {remove: this.$route.query.remove || 0}});
            this.$router.push({
                path: "/designer/team/index",
                query: {
                    ...this.$route.query
                }
            });
        },
        //显示项目成员二维码
        showQrcodePopup(name, url) {
            console.log(name, url)
            this.isQrcodePopup = !this.isQrcodePopup
            if (this.isQrcodePopup) {
                this.sQrcodeName = name;
                this.sQcCodeImg = url;
            } else {
                this.sQcCodeImg = '';
                this.sQrcodeName = '';
            }
        },
        //项目日志点击展开
        touchUnfold(index) {
            this.arrLog[index].isShow = !this.arrLog[index].isShow;
        },
        //点击施工标准
        touchStandard() {
            this.$router.push({path: "/designer/standard/index", query: {...this.$route.query}});
        },
        //点击施工报告
        touchProcess(item) {
            // this.$router.push(`/member/v2/process/detail?id=${item.rule_report_id}&projectmgnid=${this.objProject.new_srv_projectmgnid}&completed=${item.is_completed}&remove=${this.$route.query.remove || 0}`)
            // this.$router.push(`/designer/process/index?id=${item.rule_report_id}&completed=${item.is_completed}`)
            //&projectmgnid=${this.objProject.new_srv_projectmgnid}

            this.$router.push({
                path: "/designer/process/index",
                query: {id: item.rule_report_id, completed: item.is_completed, ...this.$route.query}
            });

        },
        //产品详情-查看更多
        touchLookMore() {
            this.isLookMore = !this.isLookMore;
        },
        touchBack() {
            this.$router.back();
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>
